import { useEffect, useState } from "react";
import { useFeature } from "@hackler/react-sdk";
import { sessionStorage } from "@/utils/storage";

export const useCustomFeature = (experimentKey: number): boolean => {
  const [clientVariation, setClientVariation] = useState<boolean | null>(null);
  const variation = useFeature(experimentKey);

  useEffect(() => {
    const updateClientVariation = () => {
      if (
        typeof window !== "undefined" &&
        window.location.origin.includes("localhost")
      ) {
        const test_feature = sessionStorage.get("local_test_feature");

        if (test_feature === "false" || test_feature === "true") {
          const value = test_feature === "false" ? false : true;
          setClientVariation(value);
        }
      }
    };

    updateClientVariation();
  }, []);

  return clientVariation !== null ? clientVariation : variation;
};
